// extracted by css-extract-rspack-plugin
export default {"qrCode":"NzsfvZhUCZkRvTIG"};